import React from 'react'
import OpenhouseInfo from '../EventInfo/OpenhouseInfo'
import styled from 'styled-components'
import { Box, FormControl, Grid } from '@mui/material'
import { CustomLabel } from 'components/Contact/styled-components'
import { CustomPlaceHolderInputField } from 'components/FormComponent/TextField'
import { useForm } from 'react-hook-form'
import { getFocus, useAtom, useGet } from 'state/jotai'
import { active_project, current_language } from 'state/store.global'
import { _project } from 'state/store.projects'
import { PhoneNumberDropdown } from 'components/AdvanceDropdown/PhoneNumberDropdown/Dropdown'
import { useEffect } from 'react'
import { useFetch } from 'hooks/fetch/useFetch'
import { GETLEADTOKEN } from 'api/api'
import EusButton from 'components/Button/EusButton'
import { SelectField } from 'components/MainFooter/FormField'

const Form = ({ setStep }) => {
    const language = useAtom(current_language)[0];
    const { pin, pid } = useGet(active_project) 
    const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

    const testLeadData = useFetch({ url: GETLEADTOKEN('') });

    const { register, handleSubmit, getValues, setValue, watch, control, reset, formState: { errors, isValid } } = useForm({ mode: 'onChange',
    defaultValues: {
        dateOfBirth: "",
        birth_date: "",
        birth_month: "",
        birth_year: "",
        country_id: {
        "country_id": 47,
        "name_dk": "Danmark",
        "name_eng": "Denmark",
        "country_code": "+45",
        "iso_code": "DK",
        "value": `+45 ${language === "da" ? 'Danmark' : 'Denmark' }`,
        "label": `+45 ${language === "da" ? 'Danmark' : 'Denmark' }`
        }
    },
    });

    useEffect(()=> {
        testLeadData.mutate()
    }, [language])

  return (
    <Section>
        <Heading>
            <div className = "h3">Detaljer om begivenheden</div>
            <div className = "paragraph1-regular">Denne begivenhed kræver at du tilmelder dig. Udfyld nedenstående oplysninger om dig send og klik på tilmeldsknappen.</div>
        </Heading>
        <BottomInfo>
            <OpenhouseInfo />
        </BottomInfo>
        <FormSection>
            <p className='h4'>Udfyld dine oplysninger</p>

             <Grid item xs={12}>
                <Grid sx={{ gap: "16px" }}>
                    <FormControl
                    sx={{ gap: '8px' }}
                    fullWidth
                    variant='filled'
                    >
                    <CustomLabel shrink  className="h5">
                        {buttonsLabel?.filter( btn => btn.UILabelProperty === 'FullName')[0]?.Label || 'Fuldt navn'}&nbsp;<span>*</span>
                    </CustomLabel>
                    <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                        <CustomPlaceHolderInputField
                        error={errors.firstname ? true : false}
                        helperText={buttonsLabel?.filter( btn => btn.UILabelProperty === 'firstNameErrorWarn')[0]?.Label || 'Indtast venligst et gyldigt fornavn'}
                        // label= { buttonsLabel?.filter( btn => btn.UILabelProperty === 'FirstMiddleName')[0]?.Label }
                        label={buttonsLabel?.filter( btn => btn.UILabelProperty === 'FirstMiddleName')[0]?.Label || 'Fornavn og mellemnavn'}
                        register={{...register('firstname', { required: true, validate: value => value.trim() !== "" })}}
                        />
                        <CustomPlaceHolderInputField 
                        helperText={buttonsLabel?.filter( btn => btn.UILabelProperty === 'lastNameErrorWarn')[0]?.Label || 'Indtast venligst et gyldigt'}
                        error={errors.lastname ? true : false}
                        label={buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularEfternavn')[0]?.Label}
                        register={{...register('lastname', { required: true, validate: value => value.trim() !== "" })}}
                        />
                    </Box>

                    </FormControl>
                </Grid>
            </Grid>

            <Grid item xs={12} sx={{ pt: "0 !important" }}>
                <Grid sx={{ pt: "0 !important" }}>
                    <FormControl
                    sx={{ gap: '8px' }}
                    fullWidth
                    variant='filled'
                    >
                    <CustomLabel shrink  className="h5">
                    {buttonsLabel?.filter( btn => btn.UILabelProperty === 'PrivateEmail')[0]?.Label || "Privat email"}&nbsp;<span>*</span>
                    </CustomLabel>
                    <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                            <CustomPlaceHolderInputField
                            error={errors.email ? true : false}
                            helperText={buttonsLabel?.filter( btn => btn.UILabelProperty === 'emailAddressErrorWarn')[0]?.Label || 'Indtast venligst en gyldig e-mailadresse'}
                            label={buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularEmail')[0]?.Label}
                            register={{...register('email', { required: true,  validate: (value) => {
                            const trimmedValue = value.trim();  // Trim spaces before and after the email
                            if (!trimmedValue) {
                                return false
                            }
                            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if (!emailPattern.test(trimmedValue)) {
                                return false
                            }
                            return true;
                        } })}}
                        />
                        <PhoneNumberDropdown error={errors.country_id || errors.phone ? true : false} helperText={buttonsLabel?.filter( btn => btn.UILabelProperty === 'dropdownErrorWarn')[0]?.Label || "Indtast venligst et gyldigt telefonnummer"} options={testLeadData?.D?.countries} control={control} getPhoneId={'country_id'} getPhoneNumber={'phone'} placeholder={ buttonsLabel?.filter( btn => btn.UILabelProperty === 'Country')[0]?.Label || 'Land' } description={buttonsLabel?.filter( btn => btn.UILabelProperty === 'CountryCodeDropdownDescription')[0]?.Label || "Søg landekode"} />
                    </Box>
                    </FormControl>
                </Grid>
            </Grid>

                <Grid item xs={12} sx={{ pt: "0 !important" }}>
                    <Grid sx={{ pt: "0 !important" }}>
                        <p className='h5' style={{ marginBottom: '8px' }}>Hvilken boligtype er du interesseret i?</p>
                        <SelectField control={control} placeholder={'Vælg boligtype'} name={'boligtype'} options={options} />
                    </Grid>
                </Grid>
        </FormSection>
        <Box sx={{ marginTop: '24px'}}>
            <EusButton
                icon        = {true}
                clr         = {clr}
                buttonlabel = {false}
                otherText   = {"Tilmeld dig"}
                onClick     = {() => { setStep(3) }}
                variant     = {"primary"}
                iconSize    = {"xl"}
                width       = {"max-content"}
                padding     = {"15px 30px"}
            />
        </Box>
    </Section>
  )
}

export default Form

const Section = styled.div`
  background-color: #F8F9F1;
  padding         : 16px 24px;
  overflow-y      : auto;
`

const Heading = styled.div`
    display       : flex;
    flex-direction: column;
    gap           : 16px;
`

const BottomInfo = styled.div`
    display       : flex;
    flex-direction: column;
    margin-bottom : 24px;
    margin-top : 24px;
`

const FormSection = styled.form`
    display       : flex;
    flex-direction: column;
    gap           : 24px;
`


const options = [1,2,3,4,5]